/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-18 21:37:09
 * @LastEditTime: 2019-07-24 14:41:51
 */
// 消息通知
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 获取消息列表
export const getNoticeList = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/personal/notification/findPage`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPage'
      }, params))
    }
  })
}
// 查看详情
export const getDetails = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/personal/notification/getId`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getId'
      }, params))
    }
  })
}
// 确定推荐联系人
export const addRecommend = (params, type, id) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Contact/ContactApi/referralendAdd`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'referralendAdd'
      }, params, type, id))
    }
  })
}
// 获取被推荐联系人列表
export const getRecommendList = (params, type) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Contact/ContactApi/getRec`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getRec'
      }, params, type))
    }
  })
}
